import { LinkedProvider } from './accountLink';

export interface Pet {
  baseNumber: string;
  filename: string;
}

export interface UserDto {
  id: string;
  cognitoId: string;
  email: string;
  avatarImgFilename?: string;
  pets: Pet[];
  phoneNumber?: string;
  city?: string;
  country?: string;
  street?: string;
  houseNumber?: string;
  zip?: string;
  parent_birthdate?: string;
  firstName?:string;
  lastName?:string;
  iban?:string;
  /** Identity providers linked to this account, e.g. `['google']`. */
  linkedProviders?: LinkedProvider[];
  /** Google account the login is linked to. Can differ from `email`. */
  googleLoginEmail?: string;
  /** ISO timestamp of when the Google account was linked. */
  googleLinkedAt?: string;
  /**
   * Fields of a `/save-user` request that CloudInsurance does not accept, for
   * example `["firstName"]`. The backend mailed them to customer service and
   * answered with the old value, so the response still shows the old data.
   */
  pendingSupportFields?: string[];
}
